import { useState } from "react";
import { Menu, X } from "lucide-react";

const NAV_LINKS = [
  { href: "#about", label: "About Studio", testId: "nav-link-about" },
  { href: "#services", label: "End-to-End Services", testId: "nav-link-services" },
  { href: "#gallery", label: "Spaces & Photos", testId: "nav-link-gallery" },
  { href: "#coverage", label: "Service Reach", testId: "nav-link-coverage" },
  { href: "#reviews", label: "Client Notes", testId: "nav-link-reviews" },
  { href: "#faq", label: "Process FAQ", testId: "nav-link-faq" },
  { href: "#kitchen-calculator", label: "Free Kitchen Calculator", testId: "nav-link-kitchen-calculator", highlight: true },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 bg-[#FAF6F0]/90 backdrop-blur-md border-b border-[#0D2121]/10" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <a href="#hero" className="flex items-center gap-3 group" data-testid="nav-logo-link">
          <img
            src="/assets/griham-mark.png"
            alt="Griham Design Studio logo"
            className="h-10 w-10 object-cover rounded-sm"
          />
          <span className="font-display text-xl tracking-tight text-[#0D2121] font-semibold">
            Griham Design
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-8 text-sm font-medium text-[#7A6F66]" data-testid="nav-menu">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              data-testid={link.testId}
              className={link.highlight ? "text-[#c88c2a] font-semibold hover:text-[#0D2121] transition-colors" : "hover:text-[#c88c2a] transition-colors"}
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#contact"
            data-testid="nav-start-project-btn"
            className="hidden sm:inline-flex items-center justify-center px-4 py-2 text-xs font-semibold uppercase tracking-wider text-[#0D2121] bg-[#E2A435] hover:bg-[#c88c2a] rounded-none transition-colors"
          >
            Start Project
          </a>
          <button
            type="button"
            aria-label="Toggle menu"
            data-testid="nav-mobile-toggle"
            onClick={() => setOpen(!open)}
            className="lg:hidden p-2 text-[#0D2121]"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <nav className="lg:hidden border-t border-[#0D2121]/10 bg-[#FAF6F0] px-6 py-4 flex flex-col gap-4 text-sm font-medium text-[#7A6F66]" data-testid="nav-mobile-menu">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              data-testid={`${link.testId}-mobile`}
              onClick={() => setOpen(false)}
              className={link.highlight ? "text-[#c88c2a] font-semibold hover:text-[#0D2121] transition-colors" : "hover:text-[#c88c2a] transition-colors"}
            >
              {link.label}
            </a>
          ))}
          <a
            href="#contact"
            data-testid="nav-start-project-btn-mobile"
            onClick={() => setOpen(false)}
            className="inline-flex items-center justify-center px-4 py-3 text-xs font-semibold uppercase tracking-wider text-[#0D2121] bg-[#E2A435] hover:bg-[#c88c2a] transition-colors"
          >
            Start Project
          </a>
        </nav>
      )}
    </header>
  );
};
